module.exports = __webpack_public_path__ + "assets/book.72c78be1145e17e4b3d9cd231eb2fbd11f28256ead880d487e13a391030ccde8.png";